import { useEffect, useState } from "react";
import getStockStatusContent from "./getStockStatusContent";
import getStockStatusStyle from "./getStockStatusStyle";
import { IN_STOCK } from "./stockConstants";
import styles from "./index.css";
import classnames from "classnames";

export const useAnimatedStockBanner = ({ stockStatus }) => {
  const { hidden, visible } = styles;
  const isInStock = stockStatus === IN_STOCK;

  const getBannerState = () => ({
    stockStatusStyle: getStockStatusStyle(stockStatus),
    content: getStockStatusContent(stockStatus),
    isRendered: !isInStock
  });
  const [{ stockStatusStyle, content, isRendered }, setBannerState] = useState(
    getBannerState()
  );
  const updateBannerState = () => setBannerState(getBannerState());
  const onTransitionEnd = isInStock ? updateBannerState : null;
  const [visibilityStyle, setVisibilityStyle] = useState(
    isInStock ? hidden : visible
  );
  useEffect(() => {
    if (isInStock) {
      setVisibilityStyle(hidden);
    } else {
      updateBannerState();
      requestAnimationFrame(() => {
        setVisibilityStyle(visible);
      });
    }
  }, [stockStatus]);

  return {
    isRendered,
    onTransitionEnd,
    content,
    style: classnames(stockStatusStyle, visibilityStyle)
  };
};
